import { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import { Singleton } from "../../../core/services/Singleton";
import { useDashboardStore } from "../../pages/hooks/useDashboardStore";

interface Props {
    title: any;
    data: any;
    onExport: Function;
    optionIcon?: string;
    customName?: string;
    canExport?: boolean;
}
export const ExportXLSL = ({ title, data, onExport, optionIcon, customName, canExport }: Props) => {


    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const [miData, setMiData] = useState<any>([]);

    useEffect(() => {
        let tmp: any = [];
        try {
            data.forEach((element: any) => {

                let row = element.DataBeanProperties;
                let row1: any = {};
                title.forEach((ti: any) => {
                    row1[ti.title] = row[ti.property];
                });
                tmp.push(row1);

            });

            setMiData(tmp);
        } catch (error) {

        }
    }, [data])

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(miData);

        const excelDate = (jsDate: Date) =>
            (jsDate.getTime() - new Date('1899-12-30').getTime()) / (24 * 60 * 60 * 1000);

        Object.keys(worksheet).forEach((cell) => {
            // Omitir celdas especiales como !ref, !cols, etc.
            if (!cell.match(/^[A-Z]+\d+$/)) return;

            const cellValue = worksheet[cell].v;

            // 👉 Validar si es null, undefined o cadena vacía
            if (
                cellValue === null ||
                cellValue === undefined ||
                (typeof cellValue === 'string' && cellValue.trim() === '')
            ) {
                delete worksheet[cell]; // Borra completamente la celda del worksheet
                return;
            }

            if (typeof cellValue === 'string') {
                const trimmed = cellValue.trim();

                // Detectar fecha ISO-like
                const maybeDate = new Date(trimmed);
                if (!isNaN(maybeDate.getTime()) && trimmed.match(/^\d{4}-\d{2}-\d{2}/)) {
                    worksheet[cell].t = 'n';
                    worksheet[cell].z = 'dd-mm-yyyy';
                    worksheet[cell].v = excelDate(maybeDate);
                } else if (!isNaN(Number(trimmed))) {
                    worksheet[cell].t = 'n';
                    worksheet[cell].v = Number(trimmed);
                } else {
                    worksheet[cell].t = 's';
                }
            } else if (typeof cellValue === 'number') {
                worksheet[cell].t = 'n';
            } else if (cellValue instanceof Date) {
                worksheet[cell].t = 'n';
                worksheet[cell].z = 'dd-mm-yyyy';
                worksheet[cell].v = excelDate(cellValue);
            } else {
                worksheet[cell].t = 's';
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Hoja1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileName = single.basicName(customName ? customName : 'reporte');

        onExport(fileName);

        const link = document.createElement('a');
        const url = URL.createObjectURL(dataBlob);
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
    };



    return (
        <>

            {(canExport || single.canExport()) &&
                <button title='Exportar XLSX' type="button" className="btn btn--primary btn-icon " onClick={exportToExcel}>
                    <i className={optionIcon ? `${optionIcon} m-2 icontable icontable` : 'ri-profile-line icontable icontable'}></i>
                </button>
            }
        </>
        // <BasicButton icon="" eventClick={exportToExcel}>Exportar</BasicButton>
    )
}